import { Route } from 'react-router';
import { TransactionDetailsPage } from '../TransactionDetailsPage';
import { getTransactionDetailsPath } from '../path/path';

export const TransactionDetailsRoutes = [
  <Route key={getTransactionDetailsPath()} path={getTransactionDetailsPath()} element={<TransactionDetailsPage />} />,
];
